import { Outlet } from "react-router-dom";
import NavBar from "../Components/NavBar";
import Footer from "../Components/Footer";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Layout(){
    const location = useLocation();

    useEffect(() => {
        // Scroll to the top of the page
        window.scrollTo(0, 0);
    }, [location]);
    return (
        <div>
            <header>
                <NavBar />
            </header>
            <main>
                <Outlet/>
            </main>
            <footer>
                <Footer />
            </footer>
        </div>
    );
}
